import { FILE_CATEGORY, FILE_CATEGORY_CONFIG } from "../constantes";
import type { AgrementFilesDto } from "../dto/agrement.dto";

export interface UploadedFile {
  name: string;
  uuid?: string;
  createdAt?: string | Date;
  [key: string]: unknown;
}

export const encodeFilename = (fileName: string) =>
  Buffer.from(fileName, "latin1").toString("base64");

export const decodeFilename = (encodedFileName: string) =>
  Buffer.from(encodedFileName, "base64").toString("latin1");

export const getFileNameAndExtension = (fileName: string) => {
  const dotIndex = fileName.lastIndexOf(".");

  if (dotIndex === -1) {
    return { extension: "", name: fileName };
  }

  const name = fileName.slice(0, dotIndex);
  const extension = fileName.slice(dotIndex);

  return { extension, name };
};

export const getFileUploadErrorMessage = (
  fileName?: string,
  codeError?: string,
) => {
  let description = "Une erreur est survenue lors du dépôt du document";
  if (!fileName) {
    return description;
  }
  if (!codeError) {
    return `${description} ${fileName}`;
  }
  switch (codeError) {
    case "FileIsTooLargeError":
      description = `Le fichier ${fileName} dépasse la taille maximale autorisée (5Mo)`;
      break;
    case "FileTypeError":
      description = `Le type de fichier ${fileName} n'est pas reconnu. Veuillez télécharger un fichier PDF, PNG, JPG ou JPEG.`;
      break;
    case "FileTypePdfOnlyError":
      description = `Le type de fichier ${fileName} n'est pas supporté. Veuillez télécharger un fichier PDF.`;
      break;
    case "FileExtensionError":
      description = `Le type de fichier ${fileName} n'est pas supporté. Veuillez télécharger un fichier PDF, PNG, JPG ou JPEG.`;
      break;
    case "PDFSanitizeError":
      description = `Le fichier ${fileName} n'a pas pu être sécurisé. Veuillez le remplacer par un fichier PDF valide.`;
      break;
    case "file.scan-antivirus":
      description =
        "Le fichier contient un code malveillant et ne peut pas être déposé.";
      break;
    default:
      description = `${description} ${fileName}`;
      break;
  }
  return description;
};

export const getFileCategoryLabel = (category: FILE_CATEGORY) =>
  FILE_CATEGORY_CONFIG[category as keyof typeof FILE_CATEGORY_CONFIG]?.label ??
  category;

export const getFileByCategory = ({
  category,
  files,
}: {
  category: FILE_CATEGORY;
  files?: AgrementFilesDto[] | null;
}): AgrementFilesDto | null => {
  return files?.find((file) => file.category === category) ?? null;
};

export const getFilesByCategory = ({
  category,
  files,
}: {
  category: FILE_CATEGORY;
  files?: AgrementFilesDto[] | null;
}): AgrementFilesDto[] => {
  return files?.filter((file) => file.category === category) ?? [];
};
